/**
 * @file Created on Wed Aug 29 2018
 * @author SKu
 */
import Tooltip from './Tooltip';
export default Tooltip;